import { render, staticRenderFns } from "./competitionPointExcelRecord.vue?vue&type=template&id=f50f9da2&scoped=true"
import script from "./competitionPointExcelRecord.vue?vue&type=script&lang=ts"
export * from "./competitionPointExcelRecord.vue?vue&type=script&lang=ts"
import style0 from "./competitionPointExcelRecord.vue?vue&type=style&index=0&id=f50f9da2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50f9da2",
  null
  
)

export default component.exports